import { render, staticRenderFns } from "./PayerForm.vue?vue&type=template&id=e95b4ba0&"
import script from "./PayerForm.vue?vue&type=script&lang=js&"
export * from "./PayerForm.vue?vue&type=script&lang=js&"
import style0 from "./PayerForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports